module.exports = __webpack_public_path__ + "static/media/Yamaha-Logo-gjSr5652HfV7rWqYokcVJXGTapBAyp.758f881e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Yamaha-Logo-gjSr5652HfV7rWqYokcVJXGTapBAyp.webp
// module id = 629
// module chunks = 0